import React, { useContext, useState } from 'react';
import { useFetch } from 'hooks/use-fetch';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import Modal from 'components/modal';
import MakeReportModal from 'components/product/product-make-report/components/make-report-modal';
import MakeReportConfirmModal from 'components/product/product-make-report/components/make-report-confirm-modal';

import './product-make-report.scss';

const ProductMakeReport: React.FC<{offerId: number; dealerId: number; price: number;}> = ({ offerId, dealerId, price }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const { post } = useFetch('/kontakt?reportBug=1');
    const [makeCommentModalIsOpen, setMakeCommentModalIsOpen] = useState(false);
    const [makeCommentConfirmModalIsOpen, setMakeCommentConfirmModalIsOpen] = useState(false);

    const openMakeCommentModal = (): void => {
        setMakeCommentModalIsOpen(true);
    };

    const closeMakeCommentModal = (): void => {
        setMakeCommentModalIsOpen(false);
    };

    const openMakeCommentConfirmModal = (): void => {
        setMakeCommentConfirmModalIsOpen(true);
    };

    const closeMakeCommentConfirmModal = (): void => {
        setMakeCommentConfirmModalIsOpen(false);
    };

    const onSubmit = (formData: { bugName: string[]; }): void => {
        const data = new FormData();

        data.append('SkaReportBugFormModel[offer_id]', String(offerId));
        data.append('SkaReportBugFormModel[dealer_id]', String(dealerId));
        data.append('SkaReportBugFormModel[offer_price]', String(`${parseFloat(String(price)).toFixed(2).split('.')} zł`));

        formData.bugName.forEach((item: string) => {
            data.append('SkaReportBugFormModel[subject][]', String(item));
        });

        post(data).then(() => {
            closeMakeCommentModal();
            openMakeCommentConfirmModal();
        });
    };

    return (
        <>
            <button className="product-report__button" onClick={openMakeCommentModal} type="button">
                Zgłoś uwagi
            </button>
            {
                makeCommentModalIsOpen && (
                    <Modal
                        showCloseIcon={false}
                        center={true}
                        isOpen={true}
                        onClose={closeMakeCommentModal}
                        shouldCloseOnOverlayClick={api.getDevice() === 'desktop'}
                        modalClassName="make-report-modal"
                    >
                        <MakeReportModal onSubmit={onSubmit} closeMakeCommentModal={closeMakeCommentModal}/>
                    </Modal>
                )
            }
            {
                makeCommentConfirmModalIsOpen && (
                    <Modal
                        showCloseIcon={true}
                        center={true}
                        isOpen={true}
                        onClose={closeMakeCommentConfirmModal}
                        shouldCloseOnOverlayClick={api.getDevice() === 'desktop'}
                        modalClassName="make-report-confirm-modal"
                    >
                        <MakeReportConfirmModal/>
                    </Modal>
                )
            }
        </>
    );
};

export default ProductMakeReport;
